module.exports = __webpack_public_path__ + "static/media/logo-icon.2f1b2773.svg";